import React, { Component, PropTypes } from 'react';
import AddToBody from '../helpers/AddToBody';
import { SparkModal } from '../ui/spark';

export default class ModalConfirmAssetDeletion extends Component {
    static propTypes = {
        /** whether the modal should be open or closed */
        isOpen: PropTypes.bool,
        /** whether the modal should be rendered simple or complex */
        isComplex: PropTypes.bool,
        /** whether the modal can be dismissed by clicking outside the main box */
        isNotDismissible: PropTypes.bool,
        /** Any extra CSS classes for the component */
        className: PropTypes.string,
        /** components to be rendered inside the modal */
        children: PropTypes.node,
        /** function to be called when the modal is closed */
        onClose: PropTypes.func
    };

    constructor(props) {
        super(props);
        this.state = {
            isOpen: props.isOpen
        };
        this._onModalClickBound = this._onModalClick.bind(this);
        this._onKeyupBound = this._onKeyup.bind(this);
        this._sparkModal = {};
    }

    componentDidMount() {
        if (this.state.isOpen) {
            this._initializeModal();
        }
    }

    componentDidUpdate() {
        if (this.state.isOpen) {
            this._initializeModal();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.isOpen !== this.state.isOpen) {
            if (nextProps.isOpen) {
                this.setState({ isOpen: true });
            } else {
                this.close();
            }
        }
    }

    componentWillUnmount() {
        if (this._sparkModal.isActive) {
            this._sparkModal.close();
            this._onClose(true);
        }
    }

    _initializeModal() {
        if (!this._initialized) {
            this._sparkModal = new SparkModal(this._modal);
            this._sparkModal.open();
            if (this.props.isNotDismissible) {
                this._sparkModal._removeEventListeners();
                this._sparkModal._removeWindowEventListeners();
            } else {
                if (this._sparkModal.modalEl) {
                    this._sparkModal.modalEl.addEventListener('click', this._onModalClickBound);
                }
                window.addEventListener('keyup', this._onKeyupBound);
            }
            this._initialized = true;
        }
    }

    _onModalClick() {
        if (!this._sparkModal.isActive) {
            this._onClose();
        }
    }

    _onKeyup(e) {
        if (e.keyCode === 27) {
            this._onClose();
        }
    }

    _onClose(isUnmounting) {
        this._cleanup(isUnmounting);
        this.props.onClose && this.props.onClose();
    }

    close() {
        if (this._sparkModal.isActive) {
            this._sparkModal.close();
            this._onClose();
        }
    }

    _cleanup(isUnmounting) {
        if (!isUnmounting) {
            this.setState({ isOpen: false });
        }
        if (this._sparkModal.modalEl) {
            this._sparkModal._removeEventListeners();
            this._sparkModal.modalEl.removeEventListener('click', this._onModalClickBound);
        }
        window.removeEventListener('keyup', this._onKeyupBound);
        this._initialized = false;
    }

    render() {
        return (
            this.state.isOpen && (
                <div className="spark-modal-component spark-modal" ref={el => (this._modal = el)}>
                    <div className="spark-modal__scroll">
                        <div className="spark-modal__content col-xs-12 col-sm-10 col-md-6 col-lg-8 col-xl-4">
                            <div className="spark-modal__body">
                                {!this.props.isNotDismissible && (
                                    <a className="spark-modal__close spark-icon-close" title="Close Modal"></a>
                                )}
                                {this.props.children}
                            </div>
                        </div>
                    </div>
                </div>
            )
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/modals/ModalConfirmAssetDeletion.js